var path = '/glow/component/glow-cart/tpl/glow-cart.html';
var html = "<div class=glow-cart ng-style=$ctrl.styles.header> <span class=\"col-xs-6 col-sm-push-6 cart-send\"> <a href=# ng-click=$ctrl.launchGlowCart()><span class=\"icon icon-playlist\"></span> <span ng-bind=$ctrl.cartLinkLabel></span></a> </span> <span class=\"col-xs-6 col-sm-pull-6 cart-count\"> <span class=count-number ng-bind=$ctrl.cartCount></span> items </span> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/component/glow-cart/tpl/glow-cart.html
// module id = 1693
// module chunks = 1